import moment from 'moment';
import { connect } from 'react-redux';

import LayoutConfig from '../../Config/layoutConfig';
import { showError } from '../../Actions/VisualDataAction';
import DatePickerDrop from '../Common/datePickerDrop';
import { updateUser, getUserAsync } from '../../Actions/UserAction';
import Form from '../Common/Form';
import { CountryCode, CountryPostalCode } from '../../Enum/Models';
import Loading from '../Common/Loading';
import Validation from '../Common/Validation';

class ProfileEdit extends Form {
  state = {
    ...this.state,
    loading: false,
  };

  componentDidMount() {
    super.componentDidMount(this.FormDOM);
  }

  FormDOM = [];

  fixNumbers = (str) => {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    if (typeof str === 'string') {
      for (let i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  };

  onChangeValidation(event, type, maxLength) {
    if (maxLength) {
      if (event.target.value.length > maxLength) {
        const prevVal = event.target.value.substring(0, maxLength);
        event.target.value = prevVal;
      }
    }
    let regex;
    switch (type) {
      case 'number':
        regex = /^[0-9۰-۹٠-٩]*$/;
        break;
      case 'enAlphabet':
        regex = /^[a-zA-Z ]*$/;
        break;
      case 'faAlphabet':
        regex = /^[\u0600-\u06FF ]*$/;
        break;
      case 'email':
        regex = /[^\u0600-\u06FF\s]/;
        break;
      default:
        regex = /^[a-zA-Z ]*$/;
    }

    if (!regex.test(event.target.value)) {
      const prevVal = event.target.value.substring(0, event.target.value.length - 1);
      if (regex.test(prevVal)) {
        event.target.value = prevVal;
      } else {
        event.target.value = '';
      }
    }
  }


  handleSubmit(event) {
    event.preventDefault();
    super.validateForm(event, async () => {
      let dataModelInput = this.state.DataInput;

      let phoneNumber;
      if(this.props.LAN === "IR" && this.props.userData?.phoneNumber){
        phoneNumber = this.props.userData.phoneNumber;
      }else if(dataModelInput.phoneNumber) {
        let countryCode = dataModelInput.countryCallingCode;
        if (countryCode.substring(0, 2) === '00') {
          countryCode = '+' + countryCode.substring(2);
        }
        phoneNumber = countryCode + this.fixNumbers(dataModelInput.phoneNumber);
      }else{
        phoneNumber=null;
      }

      const parameters = {
        ...this.props.userData,
        birthDay: dataModelInput.birthDay,
        displayName: dataModelInput.firstName + ' ' + dataModelInput.lastName,
        emailAddress: dataModelInput.email,
        firstName: dataModelInput.firstName,
        gender: dataModelInput.gender,
        lastName: dataModelInput.lastName,
        nationalityId: dataModelInput.nationalityId,
        phoneNumber: phoneNumber,
      };

      this.setState({ loading: true });
      const response = await updateUser(parameters);
      this.setState({ loading: false });
      if (response?.data?.success) {
        this.props.getUserAsync(response.data.result);
      } else {
        if (response?.error) {
          this.props.showError({ visibility: true, content: response.error.message });
        } else {
          this.props.showError({ visibility: true, content: 'Internal Error,Please refresh the page' });
        }
      }
      this.props.cancel();
    });
  }
  render() {
    const { Dictionary, LAN, userData } = this.props;
    const { loading } = this.state;

    let userPhoneNumber;
  
    const isStyle3 = LayoutConfig.themeClassName === 'style-3';

    return (
      <div>
        {loading ? (
          <Loading />
        ) : (
          <form id="editUser" onSubmit={this.handleSubmit.bind(this)} ref={(node) => (this.FormDOM = node)} noValidate>
            <div className="float-row">
              <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label className="form-label required">{Dictionary.firstNameEn}</label>
                  <div className="select-input-pair-holder">
                    <select className="form-select" name="gender" defaultValue={userData.gender}>
                      <option value={true}>{Dictionary.male}</option>
                      <option value={false}>{Dictionary.female}</option>
                    </select>
                    <input
                      data-validator={true}
                      onChange={e => {this.onChangeValidation(e,"enAlphabet")}}
                      className="form-input"
                      placeholder={Dictionary.firstName}
                      name="firstName"
                      type="text"
                      defaultValue={userData.firstName || ''}
                    />
                  </div>
                  <Validation model={this.state} feild="ValidatorList" name="firstName" />
                </div>
              </div>
              <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label className="form-label">{Dictionary.lastNameEn}</label>
                  <input
                    data-validator={true}
                    onChange={e => {this.onChangeValidation(e,"enAlphabet")}}
                    className="form-input"
                    placeholder={Dictionary.lastName}
                    name="lastName"
                    type="text"
                    defaultValue={userData.lastName || ''}
                  />
                  <Validation model={this.state} feild="ValidatorList" name="lastName" />
                </div>
              </div>
              {LAN === "IR" && <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    {Dictionary.email}
                  </label>
                  <input
                    data-validator={true}
                    className="form-input placeholder-right"
                    placeholder={Dictionary.enterYourEmail}
                    name="email"
                    type="email"
                    defaultValue={userData.emailAddress || ''}
                  />
                  <Validation model={this.state} feild="ValidatorList" name="email" />
                </div>
              </div>}
              <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    {Dictionary.phoneNumber}
                  </label>
                  <div className="select-input-pair-holder" dir="ltr">
                    <select 
                      className="form-select" 
                      name={'countryCallingCode'}
                      dir="ltr"
                      readOnly = {LAN === "IR" && userData.phoneNumber}
                      disabled = {LAN === "IR" && userData.phoneNumber}
                      >
                      <option disabled selected value> -- </option>
                      {CountryPostalCode.sort((a, b) => {
                        let x = a.code.toLowerCase();
                        let y = b.code.toLowerCase();
                        if (x < y) {
                          return -1;
                        }
                        if (x > y) {
                          return 1;
                        }
                        return 0;
                      }).map((item) => {
                        let seleceted = false;
                        if (userData && userData.phoneNumber) {
                          let code = item.value;
                          if (code.substring(0, 2) === '00') {
                            code = '+' + code.substring(2);
                          }
                          if (userData.phoneNumber.includes(code)) {
                            seleceted = true;
                            let phone_Number = userData.phoneNumber.replace(code, '');
                            userPhoneNumber = phone_Number;
                          }
                        }
                        return (
                          <option key={item.code} value={item.value} selected={seleceted}>
                            {item.code}
                          </option>
                        );
                      })}
                    </select>

                    <input
                      readOnly = {LAN === "IR" && userData.phoneNumber}
                      disabled = {LAN === "IR" && userData.phoneNumber}
                      className="form-input placeholder-right full-width"
                      placeholder="9XXXXXXXXX"
                      defaultValue={userPhoneNumber ? userPhoneNumber : undefined}
                      name="phoneNumber"
                      type="tel"
                    />
                  </div>
                  <Validation model={this.state} feild="ValidatorList" name="phoneNumber" />
                </div>
              </div>
              <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    {Dictionary.birthdayMiladi}
                  </label>
                  <DatePickerDrop
                    emptyDefault={true}
                    defaultValue={userData.birthDay || undefined}
                    format={'YYYY-MM-DD'}
                    name="birthDay"
                    min={'1900-01-01'}
                    max={moment().format('YYYY-MM-DD')}
                  />
                  <Validation model={this.state} feild="ValidatorList" name="birthDay" />
                </div>
              </div>
              <div className="col-small-12 col-medium-4 clear-medium-3">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    {Dictionary.nationality}
                  </label>
                  <select 
                    data-validator={true}
                    className="form-select" 
                    defaultValue={userData.nationalityId} 
                    name="nationalityId" 
                    dir="ltr"
                  >
                    <option disabled selected value="false"> -- </option>
                    {CountryCode.sort((a, b) => {
                      let x = a.code.toLowerCase();
                      let y = b.code.toLowerCase();
                      if (x < y) {
                        return -1;
                      }
                      if (x > y) {
                        return 1;
                      }
                      return 0;
                    }).map((item) => (
                      <option value={item.value} key={item.value}>
                        {item.code}
                      </option>
                    ))}
                  </select>
                  <Validation model={this.state} feild="ValidatorList" name="nationalityId" />
                </div>
              </div>
              <div className="col-small-12">
                <button className={`button margin-top margin-end ${isStyle3?"purple-btn":"red-btn"}`} type="submit">
                  {Dictionary.saveChanges}
                </button>
                <button className={`button margin-top ${isStyle3?"purple-border-btn":"grey-btn"}`} type="button" onClick={this.props.cancel}>
                  {Dictionary.cancel}
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    );
  }
}

const stateToProps = (state) => ({
  Dictionary: state.VisualData.Dictionary,
  LAN: state.VisualData.LAN,
});

const mapDispatchToProps = (dispatch) => ({
  getUserAsync: (params) => dispatch(getUserAsync(params)),
  showError: (params) => dispatch(showError(params)),
});

export default connect(stateToProps, mapDispatchToProps)(ProfileEdit);
